<template>
    <Teleport to="body">
        <div class="sf__parts__modal sf__parts__modal--review" @click="$emit('close')">
            <section class="sf__parts__modal__inner sf__parts__review" @click.stop>
                <header class="sf__parts__modal__header">
                    <h3>Review Match Details</h3>
                    <button type="button" class="sf__parts__modal__close" aria-label="Close" @click="$emit('close')">
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                            <path d="M18 6L6 18M6 6L18 18" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
                        </svg>
                    </button>
                </header>

                <div class="sf__parts__review__body">
                    <component
                        :is="productUrl ? 'a' : 'div'"
                        class="sf__parts__review__summary"
                        :href="productUrl"
                        :target="productUrl ? '_blank' : null"
                        :rel="productUrl ? 'noopener noreferrer' : null"
                        :aria-label="productUrl ? `View ${part.part} product details (opens in a new tab)` : null"
                        @click="handleProductLinkClick"
                    >
                        <img v-if="image" :src="image" :alt="part.part">
                        <div class="sf__parts__review__details">
                            <span class="sf__parts__review__position">{{ formatPosition(part.row) }} - {{ part.side }}</span>
                            <h4>{{ part.part }}</h4>
                            <p class="sf__parts__review__sku">{{ part.sku }}</p>
                            <p
                                class="sf__results__result__status sf__parts__review__status"
                                :class="statusClass"
                                v-if="status"
                            >
                                <span class="sf__results__result__status-label">{{ status.label }}</span><span class="sf__results__result__status-separator">:&nbsp;</span>
                                <PartStatusDetail :status="status" />
                            </p>
                        </div>
                        <strong class="sf__parts__review__price">{{ money(part.price_sale || part.price) }}</strong>
                    </component>

                    <div class="sf__parts__review__notices" v-if="part.exception">
                        <div class="sf__parts__notice sf__parts__notice--exception">
                            <div class="sf__parts__notice__content">
                                <h4>
                                    <span aria-hidden="true">i</span>
                                    Exception
                                </h4>
                                <p>{{ part.exception }}</p>
                            </div>
                            <img v-if="part.exception_image" :src="part.exception_image" alt="Exception details">
                        </div>
                    </div>
                </div>

                <footer class="sf__parts__modal__footer">
                    <button type="button" class="sf__parts__modal__secondary" @click="$emit('close')">Go Back</button>
                    <button type="button" class="sf__parts__modal__primary" @click="$emit('confirm')">Confirm &amp; Add</button>
                </footer>
            </section>
        </div>
    </Teleport>
</template>

<script>
import store from '../store';
import Storage from '../helpers/storage';
import PartStatusDetail from './PartStatusDetail.vue';
import {formatPartPosition} from '../helpers/helpers';

export default {
    props: ['part', 'status'],

    emits: ['close', 'confirm'],

    components: {
        PartStatusDetail
    },

    computed: {
        image() {
            return store.products[this.part.build_id]?.image || this.part.image;
        },

        productUrl() {
            const handle = store.products[this.part.build_id]?.handle;
            return handle ? `/products/${encodeURIComponent(handle)}` : null;
        },

        statusClass() {
            return this.status ? `sf__results__result__status--${this.status.key}` : '';
        }
    },

    methods: {
        handleProductLinkClick(event) {
            if (!this.productUrl) {
                event.preventDefault();
                return;
            }

            Storage.storeRecommendations(this.part.build_id, store.results_page);
            this.part.storeOptionsInStorage();
        },

        formatPosition: formatPartPosition,

        money(value) {
            if (!value) return null;
            return '$' + parseFloat(value).toFixed(2);
        }
    }
}
</script>
